import React from 'react';
import {
  Filter,
  List,
  Datagrid,
  TextField,
  EditButton,
  DateField,
  ReferenceInput,
  ReferenceField,
  SelectInput,
  Responsive,
  SimpleList,
  DateInput
} from "react-admin";

import { IngresoGrandesGeneradoresEditComponent } from "../components/IngresoGrandesGeneradores/IngresoGrandesGeneradoresEditComponent";
import { IngresoGrandesGeneradoresCreateComponent } from "../components/IngresoGrandesGeneradores/IngresoGrandesGeneradoresCreateComponent";


export const IngresoGrandesGeneradoresFilter = props => {
  return (
    <Filter {...props}>
      <DateInput label="Fecha" source="fecha" />
      <ReferenceInput reference="etapas-grandes-generadores" source="etapa">
        <SelectInput  optionText="nombre" optionValue="_id" />
      </ReferenceInput>
      <ReferenceInput reference="operarios" source="operario" sort={{ field: 'nombre', order: 'ASC' }}>
        <SelectInput  optionText="nombre" optionValue="_id" />
      </ReferenceInput>
      <ReferenceInput reference="grandes-generadores" source="generador" sort={{ field: 'nombre', order: 'ASC' }}>
        <SelectInput  optionText="nombre" optionValue="_id" />
      </ReferenceInput>
      <ReferenceInput reference="predios" source="predio" sort={{ field: 'nombre', order: 'ASC' }}>
        <SelectInput  optionText="nombre" optionValue="_id" />
      </ReferenceInput>
    </Filter>
  )
}

export const IngresoGrandesGeneradoresList = props => (
  <List {...props} bulkActions={false} filters={<IngresoGrandesGeneradoresFilter />} exporter={false}>
  <Responsive
    small={
      <SimpleList
        primaryText={record => record.etapa }
        secondaryText={record => new Date(record.fecha).toLocaleDateString() }
      />
    }
    medium={
      <Datagrid>
        <DateField source="fecha" />
        <ReferenceField label="Etapa" reference="etapas-grandes-generadores" source="etapa">
          <TextField source="nombre" />
        </ReferenceField>
        <ReferenceField label="Operario" reference="operarios" source="operario">
          <TextField source="nombre" />
        </ReferenceField>
        <ReferenceField label="Generador" reference="grandes-generadores" source="generador">
          <TextField source="nombre" />
        </ReferenceField>
        <TextField source="patente" />
        <EditButton />
      </Datagrid>
    }
  />
  </List>
);

export const IngresoGrandesGeneradoresCreate = props => (
  <IngresoGrandesGeneradoresCreateComponent {...props} />
);

export const IngresoGrandesGeneradoresEdit = props => (
    <IngresoGrandesGeneradoresEditComponent {...props} />
);



// WEBPACK FOOTER //
// ./src/services/ingresoGrandesGeneradores.js